import { Spinner } from '../../../components/Spinner/Spinner'
import { DocumentProcessingStatusType } from '../../../models/Document'

export const DOCUMENT_PROCESSING_STATUS_TEXT_MAPPING = {
  [DocumentProcessingStatusType.SAVED]: 'Saved to external system',
  [DocumentProcessingStatusType.READY]: 'Not saved, ready for review',
  [DocumentProcessingStatusType.LOADING]: 'Checking status',
  [DocumentProcessingStatusType.PROCESSING]: 'Extracting insights',
}

export const DOCUMENT_PROCESSING_STATUS_ICON_CLASS_NAME_MAPPING: Partial<Record<DocumentProcessingStatusType, string>> = {
  [DocumentProcessingStatusType.SAVED]: 'document-processing-completed-icon-container rounded-circle',
}

export const DOCUMENT_PROCESSING_STATUS_ICON_MAPPING = {
  [DocumentProcessingStatusType.SAVED]: <i className='bi bi-check zocks-text-white' />,
  [DocumentProcessingStatusType.READY]: (
    <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
      <circle cx='8' cy='8' r='6.5' fill='white' stroke='#ADB5BD' strokeWidth='3' />
    </svg>
  ),
  [DocumentProcessingStatusType.LOADING]: <Spinner size='sm' />,
  [DocumentProcessingStatusType.PROCESSING]: <Spinner size='sm' />,
}
